import type { ShopMessageKey } from '../../../i18n'

type CheckoutEmptyStateProps = {
  t: (key: ShopMessageKey) => string
  toLocalizedPath: (path: string) => string
}

export const CheckoutEmptyState = ({ t, toLocalizedPath }: CheckoutEmptyStateProps) => (
  <section className="rounded-2xl border border-slate-200 bg-white px-6 py-8 text-center shadow-sm">
    <p className="text-lg font-semibold text-slate-900">{t('checkout.empty.title')}</p>
    <p className="mt-2 text-sm text-slate-600">{t('checkout.empty.description')}</p>
    <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-semibold text-slate-800 transition hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
        onClick={() => {
          window.location.assign(toLocalizedPath('/cart'))
        }}
      >
        {t('checkout.empty.ctaCart')}
      </button>
      <button
        type="button"
        className="rounded-lg bg-emerald-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-emerald-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
        onClick={() => {
          window.location.assign(toLocalizedPath('/search'))
        }}
      >
        {t('checkout.empty.ctaCatalog')}
      </button>
    </div>
  </section>
)
